import axios from '@/lib/axios';
import { CancelRequestParams } from '../types';

const confirmCancel = (data: CancelRequestParams, custCode: string | undefined) => {
  return axios.post(`/facility/flat_rates/terminate_cancels/${custCode}/cancel_confirm`, data);
}

export default confirmCancel;